import { enableMapSet } from '@integrations/immutable'
import * as React from '@integrations/react'
import { createRoot } from '@integrations/renderer'
import { BrowserRouter } from '@integrations/routing'
import { Provider } from '@integrations/state'
import { store } from '@store'
import App from './App'
import { IntegrationProviders } from './context/IntegrationProviders'

import '@config/i18n'

import '@scss/vendor.css'
import '@scss/app.scss'

enableMapSet()

const container = document.getElementById('banky-app')
const root = createRoot(container!)

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <IntegrationProviders>
          <App />
        </IntegrationProviders>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
)
